import { api } from "../../../../convex/_generated/api";
import { useAuthQuery as useQuery } from '../../../../shared/hooks/useAuthQuery';
import { Button } from "../../../../catalyst-components/button";
import { useState } from "react";
import { parseMarkdown } from "../../../../shared/helpers/markdown";
import { useNavigate } from "react-router-dom";
import { MainRoutes } from "../../../../shared/models";
import { Dialog, DialogTitle } from "../../../../catalyst-components/dialog";
import { Doc } from "../../../../convex/_generated/dataModel";
export const GlobalEmbeddingsGrid = () => {
  const embeddings = useQuery(api.global_context_embeddings.getAllEmbeddings);
  const [filter, setFilter] = useState('');
  const [selectedEmbedding, setSelectedEmbedding] = useState<Doc<"global_context_embeddings"> | null>(null);
  const navigate = useNavigate();

  if (!embeddings) {
    return <div className="min-h-screen bg-background pt-24 p-6">Loading...</div>;
  }

  const filteredEmbeddings = embeddings.filter((embedding) =>
    embedding.text.toLowerCase().includes(filter.toLowerCase())
  );

  return (
    <div className="min-h-screen bg-background pt-24 p-4">
      <div className="flex items-center gap-4 mb-4">
        <Button color="light" onClick={() => navigate('../')}>
          Go back
        </Button>
        <h2 className="text-xl font-bold">Global Context Embeddings</h2>
      </div>
      <div className="mb-4 flex gap-2">
        <input
          type="text"
          placeholder="Filter by text..."
          className="w-full p-2 border rounded-lg"
          value={filter}
          onChange={(e) => setFilter(e.target.value)}
        />
        <Button color="light" className="w-1/4" onClick={() => setFilter('')}>Clear Filter</Button>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {filteredEmbeddings.map((embedding) => (
          <div 
            key={embedding._id} 
            className="border rounded-lg p-4 bg-white shadow hover:shadow-md transition-shadow flex flex-col h-full"
          >
            <p className="text-sm text-gray-600 mb-2">
              {new Date(embedding._creationTime).toLocaleString()}
            </p>
            <div 
              className="text-gray-800 break-words flex-grow"
              dangerouslySetInnerHTML={{
                __html: filter 
                  ? parseMarkdown(embedding.text).replace(
                      new RegExp(filter, 'gi'),
                      match => `<mark class="bg-yellow-200">${match}</mark>`
                    )
                  : parseMarkdown(embedding.text)
              }}
            />
            <div className="flex flex-row justify-end mt-4">
              <button className="rounded-full bg-primary-3 w-8 h-8 flex items-center justify-center text-white" onClick={() => setSelectedEmbedding(embedding)}>
                  {embedding.times_used || 0}
              </button>
            </div>
          </div>
        ))}
      </div>

      <Dialog open={!!selectedEmbedding} onClose={() => setSelectedEmbedding(null)}>
          <DialogTitle>Sessions Using This Context</DialogTitle>
          <div className="flex flex-col gap-2 max-h-96 overflow-y-auto p-4">
            {selectedEmbedding?.sessions_used?.map((session) => (
              <Button
                key={session}
                color="light"
                className="w-full text-left"
                onClick={() => {
                  navigate(`${MainRoutes.Chat}?sessionId=${session}&readonly=true`);
                  setSelectedEmbedding(null);
                }}
              >
                {session}
              </Button>
            ))}
            {selectedEmbedding?.sessions_used?.length === 0 && (
              <p className="text-gray-500 text-center">No sessions found</p>
            )}
          </div>
      </Dialog>
    </div>
  );
}; 